<template>
  <div>
    <button type="button" @click="$emit('clicked')" class="btn btn-brand1 btn-xs-w-100 px-5" :class="isDisabled ? 'disabled' : ''" :disabled="isDisabled ? true : false " >{{ message }}</button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonTimeSlot',
  props: {
    message: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
});
</script>
